import { Button, Col, Flex, Form, FormInstance, notification, Row, Upload } from "antd";
import ContaSelect from "../../../Conta/ContaSelect";
import { UploadOutlined } from "@ant-design/icons";
import { useProcessarRetorno } from "../../../../../../Services/Financeiro/Titulo/Pagamento/BoletoServices";
import { forwardRef } from "react";
import { PropriedadesDeNotificacao } from "../../../../../../Utils/Notificacoes";
import { EnumTipoConta } from "@/Models/Financeiro/Conta";
export type BoletoImportaRetornoFormType = {
    codConta:number;
    arquivo:File;
}
export interface IBoletoImportaRetornoFormProps {
    form?:[FormInstance<BoletoImportaRetornoFormType>];
    onSuccess?:() => void;
    onCancelar?:() => void;
}

export type BoletoImportaRetornoFormRefType = FormInstance<BoletoImportaRetornoFormType> & {
};

const BoletoImportaRetornoForm = forwardRef<BoletoImportaRetornoFormRefType, IBoletoImportaRetornoFormProps>(function BoletoImportaRetornoForm({
    form : formParam,
    onSuccess,
    onCancelar
}, ref) {
    const newForm = Form.useForm();
    const [form] = formParam ?? newForm;

    const {
        mutate,
        isPending
    } = useProcessarRetorno({
        onSuccess() {
            onSuccess?.();
            notification.open({
                ...PropriedadesDeNotificacao.Sucesso('Retorno processado com sucesso.')
            });
        }
    });

    function cancelar() {
        form.resetFields();
        onCancelar?.();
    }

    return <Form<BoletoImportaRetornoFormType>
        ref={ref}
        form={form}
        layout="vertical"
        autoComplete="off"
        component={"div"}
        onFinish={mutate}
    >
        <Row gutter={8} wrap>
            <Col xs={24}>
                <Form.Item<BoletoImportaRetornoFormType> label={"Conta"} name={["codConta"]} rules={[ { required : true } ]}>
                    <ContaSelect 
                        filtros={{
                            encerrada : false,
                            codTiposInvalidos : [EnumTipoConta.ADIANTAMENTO_VIAGEM]
                        }}
                    />
                </Form.Item>
            </Col>

            <Col xs={24}>
                <Form.Item<BoletoImportaRetornoFormType> label={"Arquivo"} name={["arquivo"]} getValueFromEvent={({file}) => file} rules={[ { required : true } ]}>
                    <Upload maxCount={1} beforeUpload={() => false} accept=".ret" multiple={false}>
                        <Button icon={<UploadOutlined />}>Carregar arquivo</Button>
                    </Upload>
                </Form.Item>
            </Col>

            <Col xs={24}>
                <Flex justify="space-between">
                    <Button type="primary" danger htmlType="button" size={"middle"} disabled={isPending} onClick={cancelar}>Cancelar</Button>
                    <Button type="primary" htmlType="button" onClick={form.submit} size={"middle"} loading={isPending}>Processar</Button>
                </Flex>
            </Col>
        </Row>
    </Form>;
});

export default BoletoImportaRetornoForm;